import { render, staticRenderFns } from "./product-bundle-bonus-table.vue?vue&type=template&id=1baa26fe&"
import script from "./product-bundle-bonus-table.vue?vue&type=script&lang=js&"
export * from "./product-bundle-bonus-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports